import http from "@/http/radar-grid/axios";
const resource = "/radargrid/objects";

export default {
  // RGオブジェクトの取得
  fetchRadarGridObjects(payload) {
    return http.get(`${resource}/latest`, {
      params: payload,
    });
  },

  // RGオブジェクトの航跡を取得
  fetchPastPath(objectId, payload) {
    return http.get(`${resource}/${objectId}/path`, {
      params: payload,
    });
  },

  // RGオブジェクトの過去履歴を取得
  fetchRadarGridHistory(payload) {
    return http.get(`${resource}/search`, {
      params: payload,
    });
  },
};
